<template>
  <div class="container">
    <div class="campus-item" v-for="(item, index) in campusList" :key="index">
      <div class="title">
        <img src="https://files.wondercv.com/pc/campusOffers/campus.png" alt="">
      </div>
      <div class="content" v-if="index <= 2">
        <div class="label">{{ item.type }}</div>
        <div class="value">{{ item.value || '以官网信息为准' }}</div>
      </div>
      <div class="content" v-if="index === 3">
        <div class="label">{{ item.type }}</div>
        <div class="value">{{ item.value || '分批次进行' }}</div>
      </div>
      <div class="content" v-if="index === 4">
        <div class="label">{{ item.type }}</div>
        <div class="value">{{ item.value || '面试结束后' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampusContainer",
  props: {
    campusList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  .campus-item {
    width: 171px;
    height: 171px;
    &:last-child {
      .title {
        width: 147px;
        overflow: hidden;
      }
    }
    //background-color: #0ec9bb;
    .title {
      width: 100%;
      height: 10px;
      display: flex;
      align-items: center;
      position: relative;
      img {
        width: 10px;
        height: 10px;
      }
      &:after {
        content: '';
        position: absolute;
        left: 10px;
        //top: 4px;
        display: block;
        width: 161px;
        height: 0;
        border-top: 1px dotted #ff6644;
      }
    }
    .content {
      width: 144px;
      height: 68px;
      margin: 13px 0 0 4px;
      box-sizing: border-box;
      padding: 16px 0 0 16px;
      //background-color: #0ec9bb;
      background: url("https://files.wondercv.com/pc/campusOffers/campusBackground.png") no-repeat;
      background-size: 100% 100%;
      .label {
        color: #404040;
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
      }
      .value {
        color: #606060;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
}
</style>